module.exports = __webpack_public_path__ + "img/toGet.1768119790257.png";